<template>
  <div class="levo__budget">
    <div class="levo__budget__nadpis">
      <div class="levo__budget__nadpis__penezenka">
        <div class="levo__budget__nadpis__penezenka--img"></div>
      </div>
      <div class="levo__budget__nadpis__text">Budget</div>
    </div>

    <div class="levo__budget__cislo">
      <div class="levo__budget__cislo__castka">
        {{ gameTeam && gameTeam.money | numbersThousands }}
      </div>
      <div class="levo__budget__cislo__mena">€</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LevoBudget",
  data() {
    return {
      budget: 0,
    };
  },
  computed: {
    ...mapGetters({
      gameTeam: "gameTeam",
    }),
  },
};
</script>
